import { apiClient } from "./apiClient";

export async function fetchDashboardStats() {
    const response = await apiClient('/api/dashboard/stats', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}

export async function fetchDashboardDeliveries() {
    const response = await apiClient('/api/dashboard/deliveries', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}

export async function fetchDashboardPurchases() {
    const response = await apiClient('/api/dashboard/purchases', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}

export async function fetchDashboardVendorBills() {
    const response = await apiClient('/api/dashboard/vendorbills', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}